// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"11a874a3","453":"c1c2f771"}[chunkId] + ".chunk.js";
};